import { number, object, ObjectSchema } from 'yup';

import { FormErrorMessage } from '~/constants/messages';

import { AllowAccessPermissionForm } from './types';

export const validationSchema: ObjectSchema<AllowAccessPermissionForm> = object().shape({
  afterDays: number().required(FormErrorMessage.required),
});
